import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { Loadable } from '../base/components/Lodable'

const RegistroCotizacionApp = Loadable(lazy(() => import('./view/CotizacionRegistro')))
const GestionCotizacionApp = Loadable(lazy(() => import('./view/GestionCotizacion')))
const ActualizarCotizacionApp = Loadable(lazy(() => import('./view/CotizacionActualizar')))
const VentaCotizacionApp = Loadable(lazy(() => import('./view/CotizacionVentaRegistro')))
const CotizacionConsultarApp = Loadable(lazy(() => import('./view/CotizacionConsultar')))
const GestionVentaCotizacionApp = Loadable(lazy(() => import('./view/GestionVentaCotizacion')))

/**
 * Mapa de rutas
 */
export const cotizacionRoutesMap = {
  registro: {
    path: '/cotizacion/registro',
    name: 'Nueva Cotización',
    actionSecure: 'administrar',
  },
  actualizar: {
    path: '/cotizacion/actualizar/:id',
    name: 'Actualizar Cotización',
    actionSecure: 'administrar',
  },
  gestion: {
    path: '/cotizacion/gestion',
    name: 'Registro Cotización',
  },
  gestionVenta: {
    path: '/cotizacion/ventas',
    name: 'Gestión de Ventas',
  },
  consultar: {
    path: '/cotizacion/consultar',
    name: 'Consultar Cotización',
  },
  venta: {
    path: '/cotizacion/venta',
    name: 'Venta Cotización',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const cotizacionRoutes = [
  {
    path: cotizacionRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <GestionCotizacionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cotizacionRoutesMap.consultar.path,
    element: (
      <OperacionesProvider>
        <CotizacionConsultarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cotizacionRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <RegistroCotizacionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cotizacionRoutesMap.actualizar.path,
    element: (
      <OperacionesProvider>
        <ActualizarCotizacionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cotizacionRoutesMap.gestionVenta.path,
    element: (
      <OperacionesProvider>
        <GestionVentaCotizacionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cotizacionRoutesMap.venta.path,
    element: (
      <OperacionesProvider>
        <VentaCotizacionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default cotizacionRoutes
